<template>
  <div class="render-fader">
    <div v-if="!renders.length" class="backdrop d-flex justify-content-center align-item-center">
      <img src="/static/images/grid.svg" />
    </div>
    <div
      v-else
      v-for="(render, i) in renders"
      :key="render"
      class="render"
      :class="{ expired: i < renders.length - 1 }"
      :style="{ backgroundImage: `url(${render})` }"
    />
  </div>
</template>

<script>
export default {
  name: 'render-fader',
  props: {
    src: String,
  },
  data() {
    return {
      renders: [],
    };
  },
  watch: {
    src: {
      handler: function srcWatcher(src) {
        // preload image so it displays immediately
        if (src) {
          const img = new Image();
          img.onload = () => {
            // append latest src to renders list
            if (!this.renders.includes(src)) {
              this.renders.push(src);
            }

            // trim renders list to prevent leaking memory
            if (this.renders.length > 2) {
              this.renders.splice(0, this.renders.length - 2);
            }
          };
          img.src = src;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.render-fader {
  position: relative;
  width: 100%;
  height: 100%;

  @keyframes fade-in {
    0% { opacity: 0; }
    100% { opacity: 1; }
  }
  @keyframes fade-out {
    0% { opacity: 1; }
    100% { opacity: 0; }
  }
  .render {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    animation: fade-in 300ms forwards;

    &.expired {
      animation-name: fade-out;
      animation-delay: 300ms;
    }
  }

  .backdrop {
    height: 100%;

    img {
      width: 200px;
      max-width: 100%;
      opacity: 0.2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/masking/RenderFader.vue